import { Component, OnInit, ChangeDetectionStrategy, input, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SelectModule
  ]
})
export class PriorityComponent implements OnInit {
  private translate = inject(TranslateService);

  readonly formGroup = input<UntypedFormGroup>(new UntypedFormGroup({}));
  readonly controlName = input<UntypedFormControl>(new UntypedFormControl());
  readonly placeHolder = input<string>('Select');
  readonly styleClass = input<string>('-ml-2 border-none surface-50 w-full text-sm');
  readonly languageCode = input<string>('en', { alias: "langCode" });
  readonly priorityData = input<string>("", { alias: "priority" });

  priority: any[] = [
    { name: 'High', value: 'high', icon: '',key:'High' },
    { name: 'Medium', value: 'medium', icon: '',key:'Med' },
    { name: 'Low', value: 'low', icon: '',key:'low' },
  ];

  constructor() {
    const languageCode = this.languageCode();
    this.translate.setDefaultLang(languageCode);
    this.translate.use(languageCode);

    let transalteKey: string[] = ['common.PRIORITY.HIGH', 'common.PRIORITY.MEDIUM', 'common.PRIORITY.LOW'];
    this.translate.get(transalteKey).subscribe(translations => {
      this.priority.find(item => item.value == 'high').name = translations['common.PRIORITY.HIGH'];
      this.priority.find(item => item.value == 'medium').name = translations['common.PRIORITY.MEDIUM'];
      this.priority.find(item => item.value == 'low').name = translations['common.PRIORITY.LOW'];
    });


  }

  ngOnInit(): void {
    if(this.priorityData() !="")
    {
      // Map priority string to the correct key
      let priorityKey = this.priorityData();
      const priorityData = this.priorityData();
      if (priorityData === 'Medium' || priorityData === 'Med') {
        priorityKey = 'Med';
      } else if (priorityData === 'Low' || priorityData === 'low') {
        priorityKey = 'low';
      } else if (priorityData === 'High') {
        priorityKey = 'High';
      }
      
      const priorityObject = this.priority.find(item => item.key == priorityKey);
      this.controlName()?.setValue(priorityObject);
    }
  }

  get Priority(): any {
    return this.controlName()?.value;
  }
}
